import React from 'react';
import { Segmented } from 'antd';
import { ApiOutlined } from '@ant-design/icons';
import { useFooterPanel } from './FooterPanelContext';
import { FOOTER_PANEL_TABS } from './FooterPanelContext';

const SEGMENT_OPTIONS = [
  {
    label: (
      <span className="varexe-footer-panel-segmented__option">
        <ApiOutlined /> API calls
      </span>
    ),
    value: FOOTER_PANEL_TABS.API_CALLS,
  },
];

function FooterPanelTabBar() {
  const { activeTab, setActiveTab } = useFooterPanel();

  return (
    <div role="tablist" className="varexe-footer-panel-tab-bar">
      <Segmented
        size="small"
        value={activeTab}
        options={SEGMENT_OPTIONS}
        onChange={setActiveTab}
        className="varexe-footer-panel-segmented"
      />
    </div>
  );
}

export default FooterPanelTabBar;
